var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignoutWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.5 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.76,9.77H6.18c-.29,0-.52-.23-.52-.52s.23-.52.52-.52h8.59c.29,0,.52.23.52.52s-.23.52-.52.52Z",
    fill: "#ffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.31,11.94l3.96-2.29c.31-.18.31-.62,0-.8l-3.96-2.29c-.31-.18-.7.04-.7.4v4.57c0,.36.39.58.7.4Z",
    fill: "#ffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.83,18.5H.56c-.31,0-.56-.25-.56-.56V.56c0-.31.25-.56.56-.56h10.27c.31,0,.56.25.56.56v3.8c0,.31-.25.56-.56.56s-.56-.25-.56-.56V1.13H1.13v16.25h9.14v-3.23c0-.31.25-.56.56-.56s.56.25.56.56v3.8c0,.31-.25.56-.56.56Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutWhite);
export default __webpack_public_path__ + "static/media/signout_white.c9662fa4916ccec6d3c97a5843186e02.svg";
export { ForwardRef as ReactComponent };